<template>
  <notifications class="mt-28 mx-10">
    <template #body="props">
      <div
        class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
      >
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <div
                v-if="props.item.type === 'error'"
                class="i-heroicons-outline-x-circle text-md text-red-400 flex-shrink-0"
                aria-hidden="true"
              />
              <div
                v-else
                class="i-heroicons-outline-check-circle text-md text-green-400"
                aria-hidden="true"
              />
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium text-gray-900">
                {{ props.item.title }}
              </p>
              <p v-show="props.item.text" class="mt-1 text-sm text-gray-500">
                {{ props.item.text }}
              </p>
              <p
                v-show="props.item.data?.actionUrl"
                class="mt-1 text-sm text-gray-500"
              >
                <Button
                  v-if="props.item.data?.actionUrl"
                  :to="props.item.data?.actionUrl"
                  target="_blank"
                  icon="i-icon-park-outline:download-two"
                  class="mx-auto sm:mx-0"
                  icon-placement="right"
                >
                  Download
                </Button>
              </p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button
                class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                @click="props.close"
              >
                <span class="sr-only">Close</span>
                <div class="i-heroicons-solid-x" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </notifications>
</template>

<style lang="postcss">
.vue-notification-wrapper {
  @apply overflow-visible mt-2;
}
.vn-fade-enter-from,
.vn-fade-leave-to {
  @apply transform translate-x-10;
}
</style>
